export default __webpack_public_path__ + "static/media/WC-Sign.980ff77b.svg";